import type { Persisted } from '../state/model';
import { dayKey, endOfDay, whenLabel } from './day';
import { dueDate } from './scheduler';

export interface Upcoming {
  /** "tomorrow", "in 3 days"… */
  when: string;
  count: number;
}

/** The next learning day with reviews due after today, and how many. */
export function nextReviews(state: Persisted, now: Date): Upcoming | null {
  const end = endOfDay(now);
  const later = Object.values(state.cards)
    .filter((c) => !state.profile.flags[c.itemId])
    .map(dueDate)
    .filter((d) => d >= end)
    .sort((a, b) => a.getTime() - b.getTime());
  if (!later.length) return null;
  const day = dayKey(later[0]);
  return { when: whenLabel(later[0], now), count: later.filter((d) => dayKey(d) === day).length };
}
